import Routes from "./routes";
import CAFoundationFreeTest from "./pages/CAFoundationFreeTest/CAFoundationFreeTest";


function App() {
  return (
    <>
      <Routes />
    </>
  );
}

export default App;
